import React, { useState } from 'react';

function App() {
  const [isHovered, setIsHovered] = useState(false);

  const containerStyle = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '60px',
   
    perspective: '1200px',
  };

  const wrapperStyle = {
    width: '1000px',
    borderRadius: '30%',
      borderTop: `10px solid #CE8238`,
          borderLeft: `10px solid #0057A4`,
            borderBottom: `10px solid #CE8238`,
          borderRight: `10px solid #0057A4`,
    overflow: 'hidden',
    transition: 'transform 0.6s ease, box-shadow 0.6s ease',
    transform: isHovered
      ? 'rotateY(0deg) rotateX(0deg) scale(1.03)'
      : 'rotateY(-8deg) rotateX(5deg)',
    boxShadow: isHovered
      ? '0 30px 60px rgba(0, 0, 0, 0.4), 0 15px 30px rgba(0, 0, 0, 0.25) inset'
      : '0 20px 40px rgba(0, 0, 0, 0.3), 0 10px 20px rgba(0, 0, 0, 0.2) inset',
    background: 'linear-gradient(135deg, #ffffff 0%, #f1f1f1 100%)',
    transformStyle: 'preserve-3d',
  };

  const imageStyle = {
    width: '100%',
    height: 'auto',
    
    display: 'block',
    borderRadius: '20px',
  };

  return (
    <div style={containerStyle}>
      <div
        style={wrapperStyle}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <img
          src="/image/CONTENT.png"
          alt="Professional 3D"
          style={imageStyle}
        />
      </div>
    </div>
  );
}

export default App;
